import { useState, useEffect } from 'react';
import { Bell, RefreshCw } from 'lucide-react';
import { useDarkMode } from '../../context/DarkModeContext';
import { api } from '../../lib/api';

interface Subscriber {
  id: number;
  email: string;
  createdAt: string;
}

export default function NewsletterTab() {
  const { darkMode } = useDarkMode();
  const [subscribers, setSubscribers] = useState<Subscriber[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.get<Subscriber[]>('/api/newsletter/subscribers');
      setSubscribers(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const card = darkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200';
  const muted = darkMode ? 'text-slate-400' : 'text-slate-500';

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold">Newsletter-Abonnenten <span className={`text-base font-normal ${muted}`}>({subscribers.length})</span></h2>
        <button onClick={load} className={`p-2 rounded-lg ${darkMode ? 'hover:bg-slate-700' : 'hover:bg-slate-100'}`}>
          <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
        </button>
      </div>

      {subscribers.length === 0 && !loading && (
        <div className={`text-center py-16 ${muted}`}>
          <Bell className="w-10 h-10 mx-auto mb-3 opacity-30" />
          <p>Noch keine Abonnenten.</p>
        </div>
      )}

      <div className={`rounded-xl border overflow-hidden ${card}`}>
        {subscribers.map((s, i) => (
          <div
            key={s.id}
            className={`flex items-center justify-between gap-3 px-4 sm:px-5 py-3 ${i > 0 ? `border-t ${darkMode ? 'border-slate-700' : 'border-slate-100'}` : ''}`}
          >
            <span className="text-sm font-medium truncate min-w-0">{s.email}</span>
            <span className={`text-xs shrink-0 ${muted}`}>{new Date(s.createdAt).toLocaleDateString('de-DE')}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
